import { motion, useReducedMotion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={reduce ? false : { opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
};

export const MaskedLines = ({ lines, className = "", delay = 0, as: Tag = "h1", ...rest }) => {
    const reduce = useReducedMotion();
    return (
        <Tag className={className} {...rest}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                    <motion.span
                        className="block will-change-transform"
                        initial={reduce ? false : { y: "115%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 1.05, delay: delay + i * 0.15, ease: EASE }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
};

export const Eyebrow = ({ children, dark = false, className = "" }) => (
    <p className={`${dark ? "eyebrow-gold" : "eyebrow-green"} ${className}`}>{children}</p>
);

export const ChapterHeading = ({ num, eyebrow, title, dark = false }) => (
    <div className="flex items-start gap-5 sm:gap-8">
        <span
            aria-hidden="true"
            className={`font-display text-5xl sm:text-7xl font-medium leading-none ${
                dark ? "text-[#C2A160]/60" : "text-[#1A3B2B]/15"
            }`}
        >
            {num}
        </span>
        <div className="pt-1 sm:pt-3">
            <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
            <h2
                className={`font-display mt-3 text-3xl sm:text-4xl font-medium tracking-tight ${
                    dark ? "text-[#FDFBF7]" : "text-[#0A1711]"
                }`}
            >
                {title}
            </h2>
        </div>
    </div>
);

export const MarqueeStrip = ({ items }) => (
    <div
        className="border-y border-[#C2A160]/20 bg-[#07211A] py-5"
        data-testid="editorial-marquee"
    >
        <Marquee speed={32} gradient={false} aria-hidden="true">
            {items.map((item) => (
                <span key={item} className="mx-8 inline-flex items-center gap-8">
                    <span className="font-display text-lg italic text-[#FDFBF7]/80">{item}</span>
                    <Sprout size={15} className="text-[#C2A160]" aria-hidden="true" />
                </span>
            ))}
        </Marquee>
    </div>
);
